import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { sanitizeHtml } from 'helpers/sanitizeHtml';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
    color: '#800000',
    paddingRight: theme.spacing(2),
  },
  content: {
    color: '#486470',
    fontSize: 14,
    lineHeight: 1.5,
    wordBreak: 'break-word',
    '& p': {
      margin: '0 0 8px',
    },
    '& p:last-child': {
      marginBottom: 0,
    },
    '& ul, & ol': {
      margin: '0 0 8px',
      paddingLeft: 20,
    },
    '& a': {
      color: '#0B9FD9',
    },
  },
  actions: {
    padding: theme.spacing(1, 3, 2),
  },
  confirm: {
    textTransform: 'none',
  },
}));

function AnnouncementModal({ open, title, content, onClose }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const sanitizedContent = sanitizeHtml(content);

  return (
    <Dialog open={open} onClose={onClose} scroll="paper" maxWidth="sm" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6" className={clsx(classes.title, 'cursor-default')}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {sanitizedContent ? (
          <div className={classes.content} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
        ) : null}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button color="primary" variant="contained" className={classes.confirm} onClick={onClose}>
          {t('BUTTON_CONFIRM')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AnnouncementModal;
